import { useContext, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useFieldArray } from "react-hook-form";
import { ProfileContext } from "../../context/ProfileContext";
import { ADD_PRESCRIPTION, BASE_URL, GET_CONSULTATION_OF_PATIENT, TOKEN } from "../../API";
import axios from "axios";
import { toast } from "react-toastify";
import jsPDF from "jspdf";
import { drawPrescription } from "./DrawPrescription";
import siteLogo from "../../Assets/Images/site_logo.png";

function PrescriptionForm({ methods, pdfRef }) {
    const [diagnosisList, setDiagnosisList] = useState([]);
    const [isCustomDiagnosis, setIsCustomDiagnosis] = useState(false);
    const { patientList } = useContext(ProfileContext);
    const { register, control, handleSubmit, formState: { errors, isSubmitting }, setValue, reset } = methods;
    const { fields, append, remove } = useFieldArray({ control, name: "medicines" });
    const headers = { token: TOKEN, "Content-Type": "multipart/form-data" };

    const onSubmit = async (data) => {
        await new Promise(r => setTimeout(r, 3000));
        try {
            // const canvas = pdfRef.current.getCanvas();

            const canvas = document.createElement("canvas");
            canvas.width = 600;
            canvas.height = 800;
            const ctx = canvas.getContext("2d");

            await drawPrescription(ctx, canvas, data, siteLogo);

            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF("p", "mm", "a4");
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = (canvas.height * pageWidth) / canvas.width;
            pdf.addImage(imgData, "PNG", 0, 0, pageWidth, pageHeight);
            const pdfBlob = pdf.output("blob");

            const formData = new FormData();
            formData.append("data", JSON.stringify(data));
            formData.append("file", pdfBlob, "prescription.pdf");


            const res = await axios.post(BASE_URL + ADD_PRESCRIPTION, formData, { headers });
            if (res.status === 200) {
                reset()
                toast.success("Prescription saved and forwarded to patient!")
            }
        }
        catch (error) {
            console.log("error :", error);
            const err = error.response?.data?.error_message || error.response?.data?.error_description || "An error occurred.";
            toast.error(err);
        }
    };

    const getPatientConsultation = async (e) => {
        try {
            const response = await axios.get(BASE_URL + GET_CONSULTATION_OF_PATIENT, { params: { patient_id: e.target.value }, headers });
            const json = response.data;
            if (json.code === 200 && json.status === true) {
                const selectedPatient = patientList.find((item) => item?._id === e.target.value);
                if (selectedPatient) {
                    setValue("patient_name", selectedPatient.full_name);
                    setValue("age", selectedPatient.age);
                    setValue("gender", selectedPatient.gender);
                    setValue("dateOfBirth", selectedPatient.dob);
                    setValue("address", selectedPatient.address);
                }
                setDiagnosisList(json.data || []);
                setIsCustomDiagnosis(false);
                setValue("diagnosis", "");
            }
        }
        catch (err) { console.error("fetch error : ", err); }
    }

    return (
        <Form className="comm_form" onSubmit={handleSubmit(onSubmit)}>
            <Row>
                <Col md={12}>
                    <Form.Group className="comn-class-inputs">
                        <Form.Label>Patient Name</Form.Label>
                        <Form.Select {...register("patient_id", { required: "Please select patient." })} onChange={getPatientConsultation}>
                            <option value="">Select Patient</option>
                            {patientList.map((item) => (<option key={item?._id} value={item?._id}>{item?.full_name}</option>))}
                        </Form.Select>
                        {errors.patient_id && (<span className="error">{errors.patient_id.message}</span>)}
                    </Form.Group>
                </Col>

                <Col md={4}>
                    <Form.Group className="comn-class-inputs">
                        <Form.Label>Age</Form.Label>
                        <Form.Control type="number" readOnly {...register("age")} />
                        {errors.age && <span className="error">{errors.age.message}</span>}
                    </Form.Group>
                </Col>

                <Col md={4}>
                    <Form.Group className="comn-class-inputs">
                        <Form.Label>Gender</Form.Label>
                        <Form.Control type="text" readOnly {...register("gender")} />
                    </Form.Group>
                </Col>

                <Col md={4}>
                    <Form.Group className="comn-class-inputs">
                        <Form.Label>Address</Form.Label>
                        <Form.Control type="text" readOnly {...register("address")} />
                    </Form.Group>
                </Col>

                <Col md={12}>
                    <Form.Group className="comn-class-inputs">
                        <Form.Label>Diagnosis</Form.Label>

                        {!isCustomDiagnosis ?
                            <Form.Select {...register("diagnosis", { required: "Please select diagnosis." })}
                                onChange={(e) => {
                                    if (e.target.value === "OTHER") {
                                        setIsCustomDiagnosis(true);
                                        setValue("diagnosis", "");
                                    }
                                }}
                            >
                                <option value="">Select Diagnosis</option>
                                {diagnosisList?.map((item, index) => <option key={index} value={item.condition}>{item.condition}</option>)}
                                <option value="OTHER">Other</option>
                            </Form.Select>
                            :
                            <Form.Control type="text" placeholder="Enter Diagnosis" {...register("diagnosis", { required: "Please enter diagnosis." })} />
                        }
                        {errors.diagnosis && (<span className="error">{errors.diagnosis.message}</span>)}
                    </Form.Group>
                </Col>
            </Row>
            <hr />

            <h1 className="m-3 fw-bolder text-center">Prescribed Medicines</h1>
            {fields.map((item, index) => (
                <Row key={item.id} className="mb-3">
                    <Col md={12}>
                        <Form.Group className="comn-class-inputs">
                            <Form.Label>Medicine Name</Form.Label>
                            <Form.Control type="text" placeholder="Medicine Name" {...register(`medicines.${index}.medicine_name`, { required: "Medicine name required", })} />
                        </Form.Group>
                    </Col>

                    <Col md={4}>
                        <Form.Group className="comn-class-inputs">
                            <Form.Label>Dosage</Form.Label>
                            <Form.Control type="text" placeholder="e.g. 500 mg" {...register(`medicines.${index}.dosage`, { required: true })} />
                        </Form.Group>
                    </Col>

                    <Col md={4}>
                        <Form.Group className="comn-class-inputs">
                            <Form.Label>Frequency</Form.Label>
                            <Form.Control type="text" placeholder="e.g. Twice daily" {...register(`medicines.${index}.frequency`, { required: true })} />
                        </Form.Group>
                    </Col>

                    <Col md={4}>
                        <Form.Group className="comn-class-inputs">
                            <Form.Label>Duration</Form.Label>
                            <Form.Control type="text" placeholder="e.g. 5 days" {...register(`medicines.${index}.duration`, { required: true })} />
                        </Form.Group>
                    </Col>

                    <Col md={12}>
                        <Form.Group className="comn-class-inputs">
                            <Form.Label>Instructions</Form.Label>
                            <textarea className="form-control" rows={2} placeholder="e.g. After food" {...register(`medicines.${index}.instructions`, { maxLength: 1000 })} />
                        </Form.Group>
                    </Col>

                    <Col md={3} className="d-flex align-items-end mb-3">
                        {fields.length > 1 && <button type="button" className="main-outline-btn" onClick={() => remove(index)}>Remove</button>}
                    </Col>
                    <hr />
                </Row>
            ))}

            <button type="button" className="main-outline-btn mb-3" onClick={() => append({ medicine_name: "", dosage: "", frequency: "", duration: "", instructions: "" })}>
                + Add Another Medicine
            </button>

            <div className="modal_pair_btns patient_referral_btns mt-3">
                <button className="main-btn" type="submit" disabled={isSubmitting}>{isSubmitting ? 'Processing...' : 'Save and forward Prescription'}</button>
                <button type="button" className="main-outline-btn">Discard Changes</button>
            </div>
        </Form>

    );
}

export default PrescriptionForm;
